<template>
  <div>
    <Title :pages="[{ icon: 'money-check', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <ModalSpentPayment :formBtn="formBtn" :dialog="dialog" :parent="parent" :spentPayment="mainItem"
        @closeDialog="updateDialog" @loadList="loadList(service)" @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        " />

      <ModalAssignSpent :formBtn="formBtn" :dialog="dialog_assign_spent" :spentPayment="mainItem"
        @closeDialog="closeDialogAssignSpent" @loadList="loadList(service)" @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        " />

      <v-btn 
        color="primary" 
        class="mb-3"
        @click="dialog = true"
        :disabled="settings && settings.require_payment_order_for_payment"
      >
        Crear Pago
      </v-btn>
      <v-alert
        v-if="settings && settings.require_payment_order_for_payment"
        type="info"
        dense
        text
        border="left"
        class="mb-5" 
      >
        <div class="d-flex align-center">
          <v-icon small class="mr-2">mdi-information</v-icon>
          <span>Para crear un pago, primero debe crear una <strong>Solicitud de Pago</strong> desde el módulo de Órdenes de Pago.</span>
        </div>
      </v-alert>
  
      <v-card>
        <div class="row mb-5 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-menu ref="desde_selected" v-model="desde_selected_open" :close-on-content-click="false"
                    :close-on-click="false" :return-value.sync="desde_selected" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-menu ref="hasta_selected" v-model="hasta_selected_open" :close-on-content-click="false"
                    :close-on-click="false" :return-value.sync="hasta_selected" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <!--<div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="monetary_account_selected"
                    autocomplete="off"
                    data-vv-as="monetary_account_selected"
                    name="monetary_account_selected"
                    item-text="name"
                    item-value="id"
                    :items="money_accounts"
                    label="Cuenta Monetaria"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>-->

                <div class="col-md-3 pt-0">
                  <v-combobox v-model="supplier_selected" autocomplete="off" data-vv-as="supplier_selected"
                    name="supplier_selected" item-text="name" item-value="id" :items="suppliers" label="Proveedor"
                    class="pt-0 mt-0" clearable></v-combobox>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <v-text-field clearable v-model="payment_number_selected" autocomplete="off" class="pt-0 mt-0"
                    label="Nº Pago"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field clearable v-model="voucher_number_selected" autocomplete="off" class="pt-0 mt-0"
                    label="Nº Comprobante"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-checkbox dense label="Pagos a cuenta" v-model="pagos_a_cuenta_selected"></v-checkbox>
                </div>

                <div class="col-md-3" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey" class="mr-2" dark :loading="dialog_export" @click="exportFile()"> Exportar
                    <font-awesome-icon class="ml-2" icon="download" /></v-btn>

                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }" @pagination="updatePagination" :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }">
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.nro_recibo }}</td>
              <td>{{ props.item.cbte_fch }}</td>
              <td>{{ props.item.supplier_name }}</td>
              <td class="text-right">{{ formatUtils.formatPrice(props.item.total_ars) }}</td>
              <td class="text-right px-3">

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="green" class="mr-2" @click="assignSpent(props.item)"> mdi-file-document-edit </v-icon>
                  </template>
                  <span>Editar comprobantes asociados</span>
                </v-tooltip>


                <v-menu offset-y v-if="props.item.has_file">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="grey" class="mr-2" v-bind="attrs" v-on="on">
                      mdi-paperclip
                    </v-icon>
                  </template>
                  <v-list>
                    <v-list-item dense @click="viewComprobante(props.item)">
                      <v-list-item-title>Ver Adjunto</v-list-item-title>
                    </v-list-item>
                    <v-list-item dense @click="confirmDeleteComprobante(props.item)">
                      <v-list-item-title>Eliminar Adjunto</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="sendEmail(props.item)"> mdi-email
                    </v-icon>
                  </template>
                  <span>Enviar email</span>
                </v-tooltip>


                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="purple" class="mr-2" v-bind="attrs" v-on="on"> print </v-icon>
                  </template>

                  <v-list>
                    <v-list-item dense @click="printItem(props.item)">
                      <v-list-item-title>Descargar comprobante</v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="printItem(props.item, true)">
                      <v-list-item-title>Ver comprobante</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- Imprimir retenciones -->
                <v-menu offset-y v-if="props.item.tributes.length > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="green" class="mr-2" v-bind="attrs" v-on="on"> mdi-file-certificate </v-icon>
                  </template>

                  <v-list>
                    <v-list-item dense v-for="tributo in props.item.tributes" :key="tributo.id" @click="printTributoItem(tributo, true)">
                      <v-list-item-title>Ver cert. {{ tributo.nro_cert || ('#' + tributo.id) }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(props.item)"> remove_red_eye
                    </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip> 

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2"
                      @click="deleteItem(props.item)"> delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogSendEmail v-if="update_access" :item="payment_send_email" :open="dialog_send_email" :formBtn="formBtn"
        :dialog="dialog_send_email" @closeDialog="closeSendEmailDialog" title="ENVIAR EMAIL"
        :loading="loading_send_email" />

      <DialogYesNo :open="dialog_settings" nameCancel="Cancelar" nameAccept="IR A CONFIGURAR" title="Enviar Email"
        message="Para poder enviar correos electrónicos es necesario que primero completes tu configuración de email."
        @cancel="dialog_settings = false" @accept="handleGoSettings" :maxWidth="500" @reload="filter" />

      <DialogYesNo :open="dialog_delete_comprobante" :title="'Confirmar eliminación'"
        :message="'¿Estás seguro de eliminar el adjunto?'" :loading="loading_delete_comprobante"
        @accept="deleteComprobanteConfirm" @cancel="cancelDeleteComprobante" />

      <DialogLoading :dialog="dialog_loading" text="Cargando..." />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete"
        @deleteItemConfirm="deleteItemConfirm" @reload="filter" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { paymentSpentService } from "@/libs/ws/paymentSpentService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import ModalSpentPayment from "@/views/Spents/ModalSpentPayment.vue";
import ModalAssignSpent from "@/views/Spents/ModalAssignSpent.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import DialogSendEmail from "@/views/Spents/DialogSendEmail.vue";
import DialogYesNo from "@/components/DialogYesNo";
import DialogLoading from "@/components/DialogLoading.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";

import { suppliersService } from "@/libs/ws/suppliersService";
export default {
  components: { Title, DialogDelete, ModalSpentPayment, ModalAssignSpent, DialogSendEmail, DialogYesNo, DialogLoading },
  mixins: [GenericMixin, RolMixin, ExportMixin, SettingsMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: paymentSpentService,
      page_title: "Pagos",
      modal_title: "Pago",
      mainItem: {
        id: 0,
        supplier: null,
        payment_method: null,
        dolar_cotiz: null,
        fch_payment_efective: null,
        spent_payment_methods: [],
        spents: [],
        tributes: [],
        cbte_fch: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        name_file: null,
        file_path: null,
        file_base64: null,
        file: null,
      },
      dialog_delete: false,
      dialog_open_afip: false,
      dialog_cbtes_asoc: false,
      spent_selected: null,
      loading_dialog: false,
      title_dialog: "",
      message_dialog: "",
      item_dialog: null,
      defaultItem: null,
      headers: [
        { text: "Numero", align: "left", sortable: true, value: "nro_recibo" },
        { text: "Fecha", align: "left", sortable: true, value: "cbte_fch" },
        { text: "Proveedor", align: "left", sortable: true, value: "supplier_name" },
        { text: "Total ARS", align: "right", sortable: true, value: "total_ars" },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      suppliers: [],
      receivers: [],
      money_accounts: [],
      desde_selected_open: false,
      hasta_selected_open: false,
      supplier_selected: null,
      receiver_selected: null,
      payment_number_selected: null,
      voucher_number_selected: null,
      monetary_account_selected: null,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      pagos_a_cuenta_selected: false,
      dialog_assign_spent: false,
      payment_send_email: null,
      dialog_send_email: false,
      dialog_settings: false,
      loading_send_email: false,
      dialog_delete_comprobante: false,
      loading_delete_comprobante: false,
      item_delete_comprobante: null,
      dialog_loading: false,
    };
  },
  mounted() {
    this.loadComboData();
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.filter();
  },
  methods: {
    //El listado trae filas planas: para los modales se pide el objeto completo por id
    async requestPayment(id) {
      try {
        const response = await this.service.get(id);
        if (response.status === true) return response.result;
        this.$toast.error(response.msg, "Error");
      } catch (e) {
        console.log("paymentSpentService.get error");
        console.log(e);
        this.$toast.error("Error al obtener el pago", "Error");
      }
      return null;
    },
    async fetchPayment(id) {
      this.dialog_loading = true;
      const payment = await this.requestPayment(id);
      this.dialog_loading = false;
      return payment;
    },
    //Sobrescriben GenericMixin: la fila del listado no alcanza para el modal
    async viewItem(item) {
      await this.openPaymentModal(item, false);
    },
    async editItem(item) {
      this.errors.clear();
      await this.openPaymentModal(item, true);
    },
    async openPaymentModal(item, is_edit) {
      const payment = await this.fetchPayment(item.id);
      if (payment == null) return;

      const index = this.list.indexOf(item);
      this.editedIndex = is_edit ? index : -1;
      this.viewdIndex = is_edit ? -1 : index;
      this.mainItem = payment;
      this.dialog = true;
    },
    //La url firmada del adjunto se resuelve al momento de abrirlo, no en el listado.
    //La pestaña se abre antes del await para que el navegador no la bloquee.
    async viewComprobante(item) {
      const tab = window.open("", "_blank");
      const payment = await this.fetchPayment(item.id);

      if (payment == null || payment.file_path == null) {
        if (tab != null) tab.close();
        return;
      }

      if (tab != null) tab.location = payment.file_path;
      else window.open(payment.file_path, "_blank");
    },
    closeSendEmailDialog() {
      this.payment_send_email = null;
      this.dialog_send_email = false;
    },
    handleGoSettings() {
      this.$router.push("/settings");
    },
    async sendEmail(item) {
      if (this.settings.email_host || this.settings.email_port || this.settings.email_username || this.settings.email_password || this.settings.email_encryption) {
        this.errors.clear();

        //El dialogo necesita el proveedor y las retenciones completas
        const payment = await this.fetchPayment(item.id);
        if (payment == null) return;

        this.editedIndex = this.list.indexOf(item);
        this.payment_send_email = payment;
        this.dialog_send_email = true;
      } else {
        this.dialog_settings = true;
      }
    },
    async assignSpent(item) {
      const payment = await this.fetchPayment(item.id);
      if (payment == null) return;

      this.mainItem = payment;
      this.dialog_assign_spent = true;
    },
    closeDialogAssignSpent() {
      this.mainItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.dialog_assign_spent = false;
    },
    closeDialog() {
      this.item_dialog = null;
      this.title_dialog = "";
      this.message_dialog = "";
      this.loading_dialog = false;
      this.dialog_open_afip = false;
    },
    getFilterParams() {
      const param = {
        raw: true, //El listado se resuelve por SQL: filas planas, sin objetos de Doctrine
        from: this.desde_selected,
        to: this.hasta_selected,
        supplier: this.supplier_selected != null ? this.supplier_selected.id : null,
        receiver: this.receiver_selected != null ? this.receiver_selected.id : null,
        monetary_account: this.monetary_account_selected != null ? this.monetary_account_selected.id : null,
        pagos_a_cuenta: this.pagos_a_cuenta_selected,
        payment_number: this.payment_number_selected,
        voucher_number: this.voucher_number_selected,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadComboData() {
      suppliersService
        .filterMinify()
        .then((response) => {
          this.suppliers = response.result;
        })
        .catch((e) => {
          console.log("suppliers.filter error");
          console.log(e);
        });

      generalService.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      generalService
        .filter()
        .then((response) => {
          this.money_accounts = response.result;
        })
        .catch((e) => {
          console.log("money_accounts.filter error");
          console.log(e);
        });

      emmiterService
        .filter({ enabled: true })
        .then((response) => {
          this.receivers = response.result;
        })
        .catch((e) => {
          console.log("emmiterService.filter error");
          console.log(e);
        });
    },
    deleteItemConfirm() {
      this.loading = true;
      paymentSpentService
        .remove({ id: this.deleteId })
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.filter();
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("paymentSpentService.filter error");
          console.log(e);
          this.$toast.error("Error exception", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
      this.dialog_delete = false;
    },
    cancelModal() {
      this.dialog = false;
    },
    exportFile() {
      var param = this.getFilterParams();
      param.raw = false; //El export necesita las entidades completas
      param.export = true;
      this.exportExcel(Constant.SECTION_SPENT_PAYMENTS + "/list", param, "Pagos.xlsx");
    },
    printTributoItem(tributo, open = false){
      this.loading = true;
      this.service
        .printTributoItem(tributo.id)
        .then((response) => {
          if (!generalService.downloadPdf(response, "certificado_" + tributo.nro_cert + ".pdf", open)) {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    printItem(item, open = false) {
      this.loading = true;
      this.service
        .print(item.id)
        .then((response) => {
          if (!generalService.downloadPdf(response, "recibo_" + item.nro_recibo + ".pdf", open)) {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirmDeleteComprobante(item) {
      this.item_delete_comprobante = item;
      this.dialog_delete_comprobante = true;
    },
    cancelDeleteComprobante() {
      this.item_delete_comprobante = null;
      this.dialog_delete_comprobante = false;
      this.loading_delete_comprobante = false;
    },
    deleteComprobanteConfirm() {
      if (!this.item_delete_comprobante) return;
      
      this.loading_delete_comprobante = true;
      paymentSpentService
        .deleteComprobante(this.item_delete_comprobante.id)
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");

            // Limpiar los campos del archivo en el item actual si es el mismo
            if (this.mainItem && this.mainItem.id === this.item_delete_comprobante.id) {
              this.mainItem.name_file = null;
              this.mainItem.file = null;
              this.mainItem.file_base64 = null;
              this.mainItem.file_path = null;
              this.mainItem.path = null;
            }

            this.filter();
            this.cancelDeleteComprobante();
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("paymentSpentService.deleteComprobante error");
          console.log(e);
          this.$toast.error("Error al eliminar el comprobante", "Error");
        })
        .finally(() => {
          this.loading_delete_comprobante = false;
        });
    },
  },
};
</script>
